import { render, staticRenderFns } from "./RetroactiveBilling.vue?vue&type=template&id=70bce02d&scoped=true&"
import script from "./RetroactiveBilling.vue?vue&type=script&lang=js&"
export * from "./RetroactiveBilling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70bce02d",
  null
  
)

export default component.exports